/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemHeartWrapper_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"Heart_viewer">;
    readonly " $refType": "ItemHeartWrapper_viewer";
};
export type ItemHeartWrapper_viewer$data = ItemHeartWrapper_viewer;
export type ItemHeartWrapper_viewer$key = {
    readonly " $data"?: ItemHeartWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemHeartWrapper_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "loadPortfolioData"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "userIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemHeartWrapper_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "loadPortfolioData"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Heart_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'abddb446fdad2128d9f357272503f7ea';
export default node;
